
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getTagsList } from '@/api/tags';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'GroupTag',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Array,
    default: []
  })
  selectTags!: [];

  private TagTableData: any = [];
  private tagSelected: any = [];
  private tagsTopMultipleSelection:any=[];
  private checkAllTag = false;
  private isIndeterminate: any = null;

  private listLoading = false

  created() {
    this.tagsTopMultipleSelection = this.selectTags;
    this.getTagsList();
  }

  private checkAllTagChange(val:any) { // 全选
    let tagsOptions:any = [];
    if (val) {
      this.TagTableData.forEach((element:any) => {
        tagsOptions.push(element);
      });
    }
    this.tagsTopMultipleSelection = tagsOptions;
    this.tagSelected = tagsOptions;
    this.isIndeterminate = this.tagSelected.length === this.TagTableData.length;
    this.$emit('checkedTagChange', this.tagsTopMultipleSelection);
  }
  private checkedTagChange(row:any) { // 单选
    let checkedCount = this.tagSelected.length;
    let _length = this.TagTableData.length;

    for (let i = 0; i < this.TagTableData.length; i++) {
      if (this.TagTableData[i].list) {
        _length += this.TagTableData[i].list.length;
      }
    }
    this.checkAllTag = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
    let arr = this.tagSelected.filter((device:any) => {
      return device.id === row.id
    })
    if (arr && arr.length > 0) {
      this.tagsTopMultipleSelection.push(row)
    } else {
      this.tagsTopMultipleSelection.splice(this.tagsTopMultipleSelection.indexOf(row), 1)
    }
    this.$emit('checkedTagChange', this.tagsTopMultipleSelection);
    // this.$emit('checkedTagChange', this.tagSelected);
  }
  private currentPage=1;
  private totalPage=1;
  private getTagsList() {
    this.listLoading = true;
    let params:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.currentPage
    };
    getTagsList(params).then(res => {
      if (res.data) {
        for (let i = 0; i < res.data.list.length; i++) {
          res.data.list[i].pname = '';
        }
        if (this.currentPage === 1) {
          this.TagTableData = res.data.list;
        } else {
          this.TagTableData = this.TagTableData.concat(res.data.list);
        }
        this.totalPage = res.data.page_count;
        this.setSelect(this.TagTableData);
      } else {
        if (this.currentPage === 1) { this.TagTableData = []; }
      }
      this.listLoading = false;
    }).catch(err => {
      this.listLoading = false;
      let msg = err.msg;
    });
  }
  private setSelect(list: any) {
    if (this.selectTags && this.selectTags.length > 0) {
      for (let i = 0; i < this.selectTags.length; i++) {
        let item: any = this.selectTags[i];
        for (let m = 0; m < list.length; m++) {
          let element: any = list[m];
          if (element.tags_id === item.id) {
            let arr = this.tagSelected.filter((v: any) => {
              return v.tags_id === item.id;
            });
            if (!arr || arr.length < 1) {
              this.tagSelected.push(element);
            }
          }
          if (element.list) {
            this.setSelect(element.list);
          }
        }
      }
      let _length = this.TagTableData.length;
      for (let i = 0; i < this.TagTableData.length; i++) {
        if (this.TagTableData[i].list) {
          _length += this.TagTableData[i].list.length;
        }
      }
      if (this.tagSelected.length === _length) {
        this.checkAllTag = true;
        this.isIndeterminate = false;
      } else if (this.tagSelected.length === 0) {
        this.checkAllTag = false;
        this.isIndeterminate = false;
      } else {
        this.checkAllTag = false;
        this.isIndeterminate = true;
      }
    }
  }
  private faultHandleCloseTag(item:any, index:number) {
    this.tagsTopMultipleSelection.splice(index, 1);
    let removeIndex = this.tagSelected.findIndex((tagItem:any)=>{
      return item.id === tagItem.id
    })
    if(removeIndex!==-1){
      this.tagSelected.splice(removeIndex,1);
    }

    let checkedCount = this.tagSelected.length;
    let _length = this.TagTableData.length;
    for (let i = 0; i < this.TagTableData.length; i++) {
      if (this.TagTableData[i].child) {
        _length += this.TagTableData[i].child.length;
      }
    }
    this.checkAllTag = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }
}
